import { useEffect } from "react";
import { useCounter } from "usehooks-ts";

export const useVisibilityChangeCount = () => {
  const { count, increment } = useCounter();
  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        increment();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [increment]);
  return count;
};
